import { RequestPointOfSaleModel } from "libs/models/point-of-sale-model";
import { ValidationModel } from "libs/models/validate-model";
import { PointOfSaleStore } from "store/slices/point-of-sale";
import translate from "utils/translations";

export const ValidateAddPointOfSaleState = (
  state: PointOfSaleStore
): ValidationModel<RequestPointOfSaleModel> => {
  let validationModel = {} as ValidationModel<RequestPointOfSaleModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (
    !state.pointOfSaleRequest.name ||
    state.pointOfSaleRequest.name === null ||
    state.pointOfSaleRequest.name === ""
  ) {
    validationModel.name = translate("Required_Text", "This field is required");
  }
  if (
    state.pointOfSaleRequest.name &&
    state.pointOfSaleRequest.name.length > 200
  ) {
    validationModel.name = translate("Long_Text", "Text is too long");
  }
  if (
    state.pointOfSaleRequest.redemptionChannelId === null ||
    !state.pointOfSaleRequest.redemptionChannelId
  ) {
    validationModel.redemptionChannelId = translate(
      "Required_Text",
      "This field is required"
    );
  }

  return validationModel;
};
